function Comp11() {
    $(document).on(
        "click",
        ".comp-11-item .comp-11-item-info-list li a",
        async (e) => {
            e.preventDefault();
            const text = (
                $(e.currentTarget).data("copy") || $(e.currentTarget).text()
            ).trim();

            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
            } else {
                const ta = $("<textarea>")
                    .val(text)
                    .css({ position: "fixed", opacity: 0 })
                    .appendTo("body");
                ta[0].select();
                document.execCommand("copy");
                ta.remove();
            }

            $(".copied-alert.default").addClass("show");
            setTimeout(
                () => $(".copied-alert.default").removeClass("show"),
                2000
            );
        }
    );
}

Comp11();
